import config from 'services/config'
import { getClient as getMimirClient } from 'services/yggdrasil/chat/mimir'
import { getClient as getAesirClient } from 'services/yggdrasil/chat/aesir'

export function getClient () {
    return config.useMimirForChat ? getMimirClient() : getAesirClient()
}

export const responseRoles = {
    ASSISTANT: 'assistant',
    USER: 'user'
}
